import { apiSlice } from '../../app/api/apiSlice'

export const userInfoAssessmentQueueApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPendingUserAssessmentQueue: builder.query({
      query: () => '/user-assessment-queue/pending',
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              { type: 'UserAssessmentQueue', id: 'PENDING' },
              ...result.map((row) => ({ type: 'UserAssessmentQueue', id: row._id })),
            ]
          : [{ type: 'UserAssessmentQueue', id: 'PENDING' }],
    }),
    getCompletedUserAssessmentQueue: builder.query({
      query: () => '/user-assessment-queue/results',
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              { type: 'UserAssessmentQueue', id: 'RESULTS' },
              ...result.map((row) => ({ type: 'UserAssessmentQueue', id: row._id })),
            ]
          : [{ type: 'UserAssessmentQueue', id: 'RESULTS' }],
    }),
    getUserAssessmentQueueById: builder.query({
      query: (id) => `/user-assessment-queue/${id}`,
      providesTags: (result, error, id) => [{ type: 'UserAssessmentQueue', id }],
    }),
    submitUserForSecondAssessment: builder.mutation({
      query: (payload) => ({
        url: '/user-assessment-queue',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: [{ type: 'UserAssessmentQueue', id: 'PENDING' }],
    }),
    updateUserAssessmentQueue: builder.mutation({
      query: ({ id, body }) => ({
        url: `/user-assessment-queue/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'UserAssessmentQueue', id: 'PENDING' },
        { type: 'UserAssessmentQueue', id: 'RESULTS' },
        { type: 'UserAssessmentQueue', id },
      ],
    }),
    deleteUserAssessmentQueue: builder.mutation({
      query: (id) => ({
        url: `/user-assessment-queue/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'UserAssessmentQueue', id: 'PENDING' },
        { type: 'UserAssessmentQueue', id: 'RESULTS' },
        { type: 'UserAssessmentQueue', id: arg?.id },
      ],
    }),
    completeUserSecondAssessment: builder.mutation({
      query: ({ id, checklistOutcome, assessorType }) => ({
        url: `/user-assessment-queue/${id}/complete`,
        method: 'PATCH',
        body: { checklistOutcome, assessorType },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: 'UserAssessmentQueue', id: 'PENDING' },
        { type: 'UserAssessmentQueue', id: 'RESULTS' },
        { type: 'UserAssessmentQueue', id: arg?.id },
      ],
    }),
  }),
})

export const {
  useGetPendingUserAssessmentQueueQuery,
  useGetCompletedUserAssessmentQueueQuery,
  useGetUserAssessmentQueueByIdQuery,
  useSubmitUserForSecondAssessmentMutation,
  useUpdateUserAssessmentQueueMutation,
  useDeleteUserAssessmentQueueMutation,
  useCompleteUserSecondAssessmentMutation,
} = userInfoAssessmentQueueApiSlice
